module.exports = __webpack_public_path__ + "img/cover-machine-learning.9aac429b.jpg";